import ConfigParameter, {gettext} from "../ConfigParameter";

export default class Anchor extends ConfigParameter {

    constructor() {
        let anchorSchema = {
            title: '',
            sectionUid: '',
            visible: true
        };

        super('anchor', 'text', gettext('Anchor'), 'hidden', anchorSchema, null, null, null, null, null);
    }

}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/Anchor.js